






















































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { CommonUtils } from '@/util/commonUtils';
import { ApiResponse, UploadFileResponse } from '@/types/response';
import { ApiRequest } from '@/types/request';

@Component({
    mixins: [validationMixin],
    props: {
        id: String,
    },
    data() {
        return {
            documentName: '',
            document: {
                file: FormData,
                filename: '',
            },
        };
    },
    validations: {
        documentName: {
            required,
        },
    },
})
export default class UploadPatientLienDocumentModal extends Vue {
    private show = true;
    private showDeleteConfirmBox = false;
    private description = '';

    private async setDocument($event: any) {
        const filename = $event.target.files[0].name.toLowerCase();
        if (filename.endsWith('.pdf') || filename.endsWith('.png') ||
        filename.endsWith('.jpeg') || filename.endsWith('.jpg')) {
            this.$data.document.file = $event.target.files[0];
            this.$data.document.filename = $event.target.files[0].name;
        } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be PDF, JPEG, PNG',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            const inputName = 'file-input';
            const element = this.$refs[inputName] as any;
            element.reset();
     }
    }
    private async removeDocument() {
        this.$data.document.file = undefined;
        this.$data.document.filename = '';
        this.showDeleteConfirmBox = false;
        const inputName = 'file-input';
        const element = this.$refs[inputName] as any;
        element.reset();
    }
    private async uploadFile(file: FormData, baseUrl: string): Promise<ApiResponse<UploadFileResponse>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: baseUrl,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}`,
            data: file,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<UploadFileResponse>(apiRequest);
        if (response.success && response.data) {
            return response;
        } else {
            CommonUtils.showError(response);
            throw new Error(JSON.stringify(response));
        }
    }

    private async uploadDocuments() {
        const patientId = this.$props.id;
        const formData = new FormData();
        formData.append('file', this.$data.document.file);
        const uploadResponse = await this.uploadFile(formData, this.$store.state.serverUrl);
        if (this.$data.documentName === 'Attorney Lien Letter of Protection (ALOP)') {
            this.$data.documentName = 'ALOP';
            this.description = 'Attorney Lien Letter of Protection (ALOP)';
        } else if (this.$data.documentName === 'Patient Lien Letter of Protection (PLOP)') {
            this.$data.documentName = 'PLOP';
            this.description = 'Patient Lien Letter of Protection (PLOP)';
        } else {
            this.description = this.$data.documentName;
        }
        const patient = await ObjectFactory.getPatientService().getPatientDetails(this.$store.state.serverUrl,
        patientId);
        let existingDocument: any;
        if (patient.success && patient.data && patient.data.documents ) {
            existingDocument = patient.data.documents.find((doc) => doc.name === this.$data.documentName);
        }
        if (uploadResponse.data && !existingDocument) {
            const iHttpService = ObjectFactory.getHttpService();
            const uploadDocumentRequest = [{
                name: this.$data.documentName,
                resourceId: uploadResponse.data.fileName,
                filename: this.$data.document.filename,
                description: this.description,
            }];
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_PATIENTS}/${patientId}/upload`,
                data: uploadDocumentRequest,
                loaderEvent: {
                    show: true,
                },
            };
            const response = await iHttpService.put<string>(apiRequest);
            if (response.success) {
                const toastEvent: ToastEvent = {
                    message: 'Document have been uploaded',
                    title: 'Success!',
                    timeout: 2000,
                    varient: 'success',
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                this.close();
            } else {
                CommonUtils.showError(response);
            }
        } else {
            const toastEvent: ToastEvent = {
                message: 'Document is already uploaded',
                title: 'Failed to upload document',
                timeout: 7000,
                varient: 'danger',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        }
    }

    private close() {
        this.$emit('close');
    }

}
